import { observer } from 'mobx-react-lite';
import { useWorkspaceStore } from '../../panels/use-workspace-store';
import { QueueStateProvider } from '../../queues/context/queue-state-provider';
import { FrUnitsList } from '../fr-units-list';
import { FrPageBody } from '../../fr-page-layout/fr-page-body';
import { FrUnitsListHeader } from './fr-units-list-header';
import { FrPage } from '../../fr-page-layout/fr-page';

export const FrUnitsListPage = observer(function FrUnitsListPage() {
    const workspacePanels = useWorkspaceStore().getActivePanels();
    const workspacePanel = workspacePanels.find(
        (panel) => panel.workspacePanelType === 'QUEUE' && panel.queue?.dataEntityType === 'UNIT'
    );
    return (
        <FrPage>
            <QueueStateProvider workspacePanel={workspacePanel!}>
                <FrUnitsListHeader />
                <FrPageBody>
                    <FrUnitsList />
                </FrPageBody>
            </QueueStateProvider>
        </FrPage>
    );
});
